import Button from "../../audi-ui-components/Button";
import Cancel from "../../audi-ui-components/icons/Cancel";
import { DEFAULT_THEME } from "../../constants";

const FileUploadField = ({
  name,
  label,
  value,
  accept = ".jpg,.jpeg,.png,.gif,.pdf",
  isInvalid,
  invalidMessage,
  onChange = ()=>{},
  onBlur = ()=>{},
  theme = DEFAULT_THEME,
}) => {
  //
  const onSelectFile = (e) => {
    if (e.target.files) {
      onChange(e.target.files[0]);
      setTimeout(onBlur, 1000);
    }
  }

  return (
    <div className="form-field">
      <div className="file-field">
        <p className="label">{label}</p>
        {!value?.name && <label className="aui-button aui-button--secondary">
          <input type="file" name={name} accept={accept} onChange={onSelectFile} />
          Choose file
        </label>}
        {value?.name && <span className="file">
          <span className="file-name"><span className="file-name-text">{value.name}</span></span>
          <Button variant="icon" icon={<Cancel small />} onClick={() => { onChange(null); }} theme={theme === "dark" ? "light" : null} />
        </span>}
      </div>
      {isInvalid && invalidMessage && <span className="aui-textfield__error">{invalidMessage}</span>}
    </div>
  );
};

export default FileUploadField;
